// extracted by css-extract-rspack-plugin
module.exports =  {"root":"a6980d00d5","icon":"c7de3b7b47","title":"b78666a923","text":"c5d8253818"};